(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  const bar = document.querySelector('.section-announcement-bar__carousel');
  if (!bar) return;

  const slides = Array.from(bar.querySelectorAll('.section-announcement-bar__slide'));
  if (slides.length <= 1) return;

  let current = 0;
  let timer = null;

  const autoRotate = bar.dataset.autoRotate === 'true';
  const speed = parseInt(bar.dataset.rotateSpeed, 10) || 4200;

  function show(index) {
    slides[current].classList.remove('is-active');
    slides[current].setAttribute('aria-hidden', 'true');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    slides[current].setAttribute('aria-hidden', 'false');
  }

  function next() { show(current + 1); }

  if (autoRotate) {
    timer = setInterval(next, speed);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var accordions = document.querySelectorAll('.section-collapsible-content__accordion');

    accordions.forEach(function (accordion) {
      accordion.addEventListener('click', function (event) {
        var clickedDetails = event.target.closest('.section-collapsible-content__row');
        if (!clickedDetails) return;

        // Only act when the details is being opened
        // (browser toggles [open] before the event fires on some browsers,
        // so we check after a microtask)
        requestAnimationFrame(function () {
          if (!clickedDetails.open) return;

          var allRows = accordion.querySelectorAll('.section-collapsible-content__row');
          allRows.forEach(function (row) {
            if (row !== clickedDetails && row.open) {
              row.open = false;
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ─── Arabic-digit helper ───
    var arabic = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    function toArabicDigits(str) {
      return String(str).replace(/\d/g, function (d) {
        return arabic[+d];
      });
    }
    document.querySelectorAll('[data-arabic-digits]').forEach(function (el) {
      el.textContent = toArabicDigits(el.textContent);
    });

    // ─── Per-section setup: variant chips + add-to-cart, scoped per form ───
    document.querySelectorAll('[data-featured-product-section]').forEach(function (section) {
      // Swap the visible product image when a variant chip is picked.
      // Chips may carry `data-variant-image`; the wrapper carries `data-default-image`
      // so variants without their own image fall back to the product's featured image.
      function swapVariantImage(chip) {
        var visual = chip.closest('[data-featured-product-section]').querySelector('[data-featured-product-visual]');
        if (!visual) return;
        var img = visual.querySelector('img');
        if (!img) return;
        var target = chip.getAttribute('data-variant-image') || visual.getAttribute('data-default-image');
        if (!target || img.src === target || img.src.endsWith(target)) return;

        visual.classList.add('is-swapping');
        setTimeout(function () {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = target;
          if (img.complete) {
            visual.classList.remove('is-swapping');
          } else {
            img.addEventListener('load', function onLoad() {
              visual.classList.remove('is-swapping');
              img.removeEventListener('load', onLoad);
            });
          }
        }, 150);
      }

      // Variant chip selection — scoped to each chip group inside this section
      section.querySelectorAll('[data-featured-variants]').forEach(function (chipsWrap) {
        chipsWrap.querySelectorAll('.section-featured-product__chip').forEach(function (chip) {
          chip.addEventListener('click', function () {
            chipsWrap.querySelectorAll('.section-featured-product__chip').forEach(function (c) {
              c.classList.remove('is-selected');
              var input = c.querySelector('input[type="radio"]');
              if (input) input.checked = false;
            });
            chip.classList.add('is-selected');
            var input = chip.querySelector('input[type="radio"]');
            if (input) input.checked = true;

            // Update price display for this product card
            var form = chip.closest('form');
            if (!form) return;
            var priceMain = form.querySelector('[data-price-main]');
            var priceCompare = form.querySelector('[data-price-compare]');
            var newPrice = chip.getAttribute('data-price');
            var newCompare = chip.getAttribute('data-compare-at-price');
            if (priceMain && newPrice) {
              priceMain.textContent = toArabicDigits(newPrice);
            }
            if (priceCompare) {
              if (newCompare) {
                priceCompare.textContent = toArabicDigits(newCompare);
                priceCompare.hidden = false;
              } else {
                priceCompare.textContent = '';
                priceCompare.hidden = true;
              }
            }

            // Swap product image to the variant's image (or fall back)
            swapVariantImage(chip);
          });
        });
      });

      // Add-to-cart — one handler per featured-product form in this section
      section.querySelectorAll('form[id^="featured-product-form-"]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[data-add-to-cart]');
          if (!btn || btn.disabled) return;
          btn.disabled = true;
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');
          var data = new FormData(form);
          fetch('/cart/add.js', { method: 'POST', body: data })
            .then(function (r) {
              return r.json().then(function (j) {
                return { ok: r.ok, body: j };
              });
            })
            .then(function (res) {
              if (!res.ok) throw res.body;
              btn.classList.remove('is-loading');
              btn.classList.add('is-added');
              btn.removeAttribute('aria-busy');
              window.dispatchEvent(new CustomEvent('cart:updated'));
              window.dispatchEvent(new CustomEvent('cart:open'));
              setTimeout(function () {
                btn.classList.remove('is-added');
                btn.disabled = false;
              }, 1600);
            })
            .catch(function () {
              btn.classList.remove('is-loading');
              btn.removeAttribute('aria-busy');
              btn.disabled = false;
            });
        });
      });

      // Tab nav switching
      var tabs = section.querySelectorAll('.section-featured-product__tab');
      var panels = section.querySelectorAll('.section-featured-product__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab-target');
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-tab-panel') !== target;
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var openBtn = document.querySelector('[data-header-open]');
    var closeBtn = document.querySelector('[data-header-close]');
    var drawer = document.querySelector('[data-header-drawer]');
    var overlay = document.querySelector('[data-header-overlay]');

    if (!openBtn || !closeBtn || !drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-forest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('.section-hero-forest__cta--primary[data-scroll-featured]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      var target = document.getElementById('featured');
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 60;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab-btn]');
      var panels = root.querySelectorAll('[data-tab-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.target;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.dataset.tabPanel === target;
            p.classList.toggle('is-active', on);
            if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-related-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn.disabled) return;
        btn.disabled = true;
        var orig = btn.textContent;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (data.status) { btn.disabled = false; btn.textContent = orig; return; }
          btn.textContent = '✓';
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: data } }));
          window.dispatchEvent(new CustomEvent('cart:open'));
          setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1500);
        }).catch(function () { btn.disabled = false; btn.textContent = orig; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSlideshow(section) {
    var slides = section.querySelectorAll('.section-slideshow__slide');
    var dots = section.querySelectorAll('.section-slideshow__dot');
    var prevBtn = section.querySelector('.section-slideshow__arrow--prev');
    var nextBtn = section.querySelector('.section-slideshow__arrow--next');
    var playPauseBtn = section.querySelector('.section-slideshow__playpause');

    if (slides.length <= 1) return;

    var current = 0;
    var total = slides.length;
    var autoplay = section.dataset.autoplay === 'true';
    var speed = parseInt(section.dataset.speed, 10) || 5000;
    var timer = null;
    var isPlaying = autoplay;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = (index + total) % total;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, speed);
      isPlaying = true;
      if (playPauseBtn) {
        playPauseBtn.dataset.playing = 'true';
        playPauseBtn.setAttribute('aria-pressed', 'true');
        playPauseBtn.setAttribute('aria-label', playPauseBtn.closest('[data-pause-label]')
          ? playPauseBtn.closest('[data-pause-label]').dataset.pauseLabel
          : '');
      }
    }

    function stopAutoplay() {
      clearInterval(timer);
      isPlaying = false;
      if (playPauseBtn) {
        playPauseBtn.dataset.playing = 'false';
        playPauseBtn.setAttribute('aria-pressed', 'false');
      }
    }

    function toggleAutoplay() {
      if (isPlaying) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }

    // Pause on hover / focus-within
    section.addEventListener('mouseenter', function () {
      if (isPlaying) clearInterval(timer);
    });
    section.addEventListener('mouseleave', function () {
      if (isPlaying) timer = setInterval(next, speed);
    });
    section.addEventListener('focusin', function () {
      if (isPlaying) clearInterval(timer);
    });
    section.addEventListener('focusout', function (e) {
      if (isPlaying && !section.contains(e.relatedTarget)) {
        timer = setInterval(next, speed);
      }
    });

    // Arrow buttons
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); if (isPlaying) { clearInterval(timer); timer = setInterval(next, speed); } });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); if (isPlaying) { clearInterval(timer); timer = setInterval(next, speed); } });

    // Dot buttons
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index, 10));
        if (isPlaying) { clearInterval(timer); timer = setInterval(next, speed); }
      });
    });

    // Play/pause button
    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', toggleAutoplay);
    }

    // Keyboard support
    section.addEventListener('keydown', function (e) {
      var isRtl = document.documentElement.dir === 'rtl';
      if (e.key === 'ArrowLeft') { isRtl ? next() : prev(); }
      if (e.key === 'ArrowRight') { isRtl ? prev() : next(); }
    });

    // Touch/swipe support
    var touchStartX = null;
    section.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    section.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var delta = e.changedTouches[0].clientX - touchStartX;
      var isRtl = document.documentElement.dir === 'rtl';
      if (Math.abs(delta) > 40) {
        if (delta < 0) { isRtl ? prev() : next(); }
        else { isRtl ? next() : prev(); }
      }
      touchStartX = null;
    }, { passive: true });

    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      autoplay = false;
      isPlaying = false;
    } else if (autoplay) {
      startAutoplay();
    }
  }

  // Init all slideshows on the page
  document.querySelectorAll('.section-slideshow').forEach(initSlideshow);

  // Theme editor: re-init on section load
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.section-slideshow');
    if (section) initSlideshow(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
